import {MaterialColor} from "@generated"

export interface MaterialColorLabel {
    color: MaterialColor
    label: string
    hex: string
}

export const MaterialColorLabels: Map<MaterialColor, MaterialColorLabel> = new Map<MaterialColor, MaterialColorLabel>([
    [MaterialColor.Black, {color: MaterialColor.Black, label: "Black", hex: "#000000"}],
    [MaterialColor.White, {color: MaterialColor.White, label: "White", hex: "#FFFFFF"}],
    [MaterialColor.Grey, {color: MaterialColor.Grey, label: "Grey", hex: "#8E8E92"}],
    [MaterialColor.Brown, {color: MaterialColor.Brown, label: "Brown", hex: "#a8734e"}],
    [MaterialColor.Red, {color: MaterialColor.Red, label: "Red", hex: "#e66463"}],
    [MaterialColor.Orange, {color: MaterialColor.Orange, label: "Orange", hex: "#fda159"}],
    [MaterialColor.Yellow, {color: MaterialColor.Yellow, label: "Yellow", hex: "#fbd361"}],
    [MaterialColor.Green, {color: MaterialColor.Green, label: "Green", hex: "#7ed68f"}],
    [MaterialColor.Blue, {color: MaterialColor.Blue, label: "Blue", hex: "#6fa2f1"}],
    [MaterialColor.Purple, {color: MaterialColor.Purple, label: "Purple", hex: "#9989bf"}],
    [MaterialColor.Pink, {color: MaterialColor.Pink, label: "Pink", hex: "#da78ac"}],
    [
        MaterialColor.Multicolor,
        {
            color: MaterialColor.Multicolor,
            label: "Multicolor",
            hex: "radial-gradient(circle at center, rgba(255, 255, 255, 0.6) 0%, transparent 85%), conic-gradient(#ff6b8b, #feca57, #1dd1a1, #48dbfb, #5f27cd, #ff6b8b)",
        },
    ],
])
